import DialogWrapper from '@/_components/dialog/wrapper/wrapper.vue'

import vuetify from '@/plugins/vuetify'
import { i18n } from '@/plugins/i18n'
import router from '@/_router'
import store from '@/store'
import { ApolloProvider } from 'vue-apollo'
import { accessClient, courseClient, projectClient, userClient } from '@/apolloClient'

export function openDialog(dialogComponent, props = {}): Promise<any> {
    return new Promise((resolve) => {
        const dialog = new (DialogWrapper as any)({
            propsData: { dialogComponent, props },
            router,
            store,
            i18n,
            vuetify,
            apolloProvider: new ApolloProvider({
                defaultClient: courseClient,
                clients: {
                    access: accessClient,
                    default: courseClient,
                    project: projectClient,
                    user: userClient,
                },
            }),
        })

        dialog.$mount()
        document.getElementById('top-dialog')?.appendChild(dialog.$el)
        dialog.$on('close', function (value) {
            dialog.$destroy()
            dialog.$el.remove()
            resolve(value)
        })
    })
}
